import fetch from '@/utils/fetch'
import {wymsFetch} from '@/utils/fetch'

/**
 * 统一处理请求参数
 * */
function filterURLSearchParams(args = {}) {
    const params = new URLSearchParams();
    Object.keys(args).forEach(key => {
        params.append(key, args[key])
    });
    return params
}

/**
 * 安装完成后回调地址
 * */
export function suiteAuthInfo(args) {
    return wymsFetch({
        url: 'suiteAuth/auth',
        method: 'POST',
        data: filterURLSearchParams(args)
    })
}

/**
 * 管理员注册
 * */
export function doAdminUserRegist(args) {
    return wymsFetch({
        url: 'suiteAuth/doAdminUserRegist',
        method: 'POST',
        data: filterURLSearchParams(args)
    })
}

// 获取管理员信息
export function getAdminInfo(args) {
    return wymsFetch({
        url: 'suiteAuth/getAdminInfo',
        method: 'GET',
        params: filterURLSearchParams(args)
    })
}



// WEBPACK FOOTER //
// ./src/api/infoSet.js